import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Log error to state
    this.setState({ error, errorInfo })
    // Send error to backend for logging
    this.logErrorToService(error, errorInfo)
  }

  logErrorToService = async (error, errorInfo) => {
    const hostname = window.location.hostname
    let BASE_URL = ''

    if (hostname === 'admin.exitfund.com') {
      BASE_URL = 'https://api.exitfund.com'
    } else if (hostname === 'admin.stg.exitfund.com') {
      BASE_URL = 'https://api.stg.exitfund.com'
    } else {
      BASE_URL = 'http://127.0.0.1:7000'
    }

    const errorDetails = {
      error: error.toString(),
      stack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
    }
    // console.log({ errorDetails })
    try {
      await fetch(`${BASE_URL}/error/frontend-error-logger`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(errorDetails),
      })
    } catch (err) {
      console.error('Failed to send error log to server:')
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong. Please try again later.</h1>
    }
    return this.props.children
  }
}

export default ErrorBoundary
